import { Button, Swiper } from 'antd-mobile-v5'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { useMergeCerts } from '../../services/hooks'
import { showAlert } from '../common/utils'
import LightenCert from '../Cert/LightenCert'

import styles from './css/EcardsListFooter.module.css'

const EcardsListFooter = ({ profile, nextCerts, ecards }) => {
  const { formatMessage } = useIntl()
  const { pathname } = useLocation()
  const swiperRef = useRef(null)
  const [swiperCount, setSwiperCount] = useState(0)
  const { loading, run } = useMergeCerts({
    onSuccess: () => {
      showAlert(formatMessage({ id: 'certlist-merge-submit' }), formatMessage({ id: 'common-close' }))
    },
  })

  useEffect(() => {
    if (swiperRef.current) {
      const swiperInstance = swiperRef.current
      const itemCount = swiperInstance.querySelectorAll('.adm-swiper-item').length
      setSwiperCount(itemCount)
    }
  }, [])

  return (
    <>
      <div
        className={styles['change-email']}
        style={{ borderLeft: ecards.length === 0 ? 'none' : '2px solid #29489E' }}
      >
        <Button
          color="primary"
          fill="none"
          size="mini"
          className={styles.text}
          loading={loading}
          loadingText={formatMessage({ id: 'certlist-merge-loading' })}
          onClick={run}
        >
          <FormattedMessage id="certlist-merge-certs" />
        </Button>
      </div>
      {nextCerts && (
        <div className={styles['bottom-wrapper']} ref={swiperRef}>
          <Swiper
            id="bottom-wrapper"
            stuckAtBoundary={false}
            slideSize={80}
            trackOffset={swiperCount > 1 ? 0 : 10}
            indicator={() => null}
          >
            {nextCerts &&
              Object.keys(nextCerts).map((type) => {
                return (
                  <Swiper.Item>
                    <LightenCert cert={nextCerts[type]} type={type} />
                  </Swiper.Item>
                )
              })}
          </Swiper>
        </div>
      )}
      {pathname.indexOf('/ecards') < 0 && <div style={{ width: '100%', height: '58px' }}></div>}
    </>
  )
}

export default EcardsListFooter
